module.exports = __webpack_public_path__ + "media/Metro.ad683841.mp3";